export default __webpack_public_path__ + "static/markings-dd2963b02e17f930d9c86ea0104d0a03.png";